module.exports = __webpack_public_path__ + "img/bg_mgm_home.aeca4050.png";